module.exports = __webpack_public_path__ + "market/static/img/title.a51d77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/title.png
// module id = v6VO
// module chunks = 1